import { RouteComponentProps } from 'react-router';

type History = RouteComponentProps['history'];

export class HistoryStore {
	private history?: History;

	setHistory = (history: History) => {
		this.history = history;
	};

	redirectTo = (to: string) => {
		const { history } = this;
		if (history) {
			history.push(to);
		}
	};
}
